export const SHORT_DEFAULT_ROUTE = "::/0";

export const LONG_DEFAULT_ROUTE = "0000:0000:0000:0000:0000:0000:0000:0000/0";

export const MAX_IPV6_ADDRESS_SUMMARY = 5;

export const MIN_IPV6_ADDRESS_SUMMARY = 2;

export const ZERO_FIELD = "0000";

export const TWO_ZERO_FIELDS = "0000:0000";

export const THREE_ZERO_FIELDS = "0000:0000:0000";

export const FOUR_ZERO_FIELDS = "0000:0000:0000:0000";

export const FIVE_ZERO_FIELDS = "0000:0000:0000:0000:0000";

export const SIX_ZERO_FIELDS = "0000:0000:0000:0000:0000:0000";

export const SEVEN_ZERO_FIELDS = "0000:0000:0000:0000:0000:0000:0000";

export const EIGHT_ZERO_FIELDS = "0000:0000:0000:0000:0000:0000:0000:0000";
